import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';

export const CONFIG: TableFilterSelectOption[] = [
  {
    key: EnrichmentTypeEnum.ALL,
    value: 'All Types',
  },
  {
    key: EnrichmentTypeEnum.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: {
      color: (p) => p.palette.primary[500],
    },
  },
  {
    key: EnrichmentTypeEnum.PERSON,
    value: 'People',
    icon: 'people-alt-outline',
    iconSx: {
      color: (p) => p.palette.success[500],
    },
  },
];
